import { useSyncExternalStore } from "react";

/** Whether the Tutor wants the phone's bottom tab bar out of the way: inside a class chat, in the full-screen
 * search and during a call (desktop-boards-31, phone-rtl-10). The tutor tab's class list keeps the bar.
 * PageWrapper reads it; TutorRoute writes it and clears it when it unmounts. */
let hidden = false;
const listeners = new Set<() => void>();
export function setTutorHidesPhoneTabBar(value: boolean): void {
  if (hidden === value) return;
  hidden = value;
  for (const listener of [...listeners]) listener();
}
export function useTutorHidesPhoneTabBar(): boolean {
  return useSyncExternalStore(listener => { listeners.add(listener); return () => { listeners.delete(listener); }; }, () => hidden, () => false);
}
